import { render, staticRenderFns } from "./FooterNavigationMeta.vue?vue&type=template&id=29bc0bb5"
import script from "./FooterNavigationMeta.vue?vue&type=script&lang=js"
export * from "./FooterNavigationMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLink: require('/vercel/path0/components/shared/AppLink.vue').default})
